// src/mixins/mainPageMixin.js
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('report_list', ['selected_report'])
  },
  methods: {
    navigateLink(link) {
      // 내부 링크는 현재 창에서 SPA/페이지 이동, 외부 링크도 현재 창에서 이동.
      // (이전엔 모두 새 탭이었으나 #356 요구사항에 따라 현재 창으로 변경)
      if (!link) return;
      const viewerPrefix = `https://report.qesg.co.kr/v`;
      const resolved = link.startsWith(viewerPrefix) ? this.handlePrefixMatch(link) : link;
      if (!resolved) return;
      window.location.href = resolved;
    },

    handlePrefixMatch(link) {
      if (this.selected_report && this.selected_report.state >= 4) {
        return link;
      } else {
        const { lv1, lv2, lv3 } = this.extractLvFromLink(link);
        if (lv1 && lv2) {
          const routeOptions = {
            name: 'FullView',
            query: {
              lv1: lv1,
              lv2: lv2
            }
          };

          if (lv3) {
            routeOptions.hash = lv3;
          }

          const fullViewPath = this.$router.resolve(routeOptions).href;
          return fullViewPath;
        } else {
          return null;
        }
      }
    },
    extractLvFromLink(link) {
      try {
        const url = new URL(link, window.location.origin); // 상대 경로인 경우를 대비하여 베이스 URL을 지정
        const lv1 = url.searchParams.get('lv1');
        const lv2 = url.searchParams.get('lv2');
        const lv3 = url.hash ? url.hash : null;
        return { lv1, lv2, lv3 };
      } catch (error) {
        this.$Sentry.captureException(error);
        return { lv1: null, lv2: null, lv3: null };
      }
    }
  }
};
